<template>
  <div>
    <v-container id="search-container">
      <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
      <v-form v-model="valid" lazy-validation>
        <v-row dense>
          <p class="mb-0 font-weight-bold">
            Enter search criteria. No criteria returns ALL records (may take a
            little while)
          </p>
        </v-row>
        <v-row dense>
          <v-col cols="12" v-if="picker_show">
            <div class="d-flex flex-column">
              <v-date-picker v-model="sterm.dates" range></v-date-picker>
              <v-btn @click="toggle_picker" text>Close</v-btn>
            </div>
          </v-col>
          <v-col cols="12" v-if="picker_show == false">
            <v-text-field
              v-model="dateRangeText"
              label="Date Range (click to change)"
              prepend-icon="mdi-calendar"
              readonly
              @click="toggle_picker"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <p class="my-0 font-weight-bold">Filter by</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              attach
              v-model="sterm.team"
              :items="['-51-', '-55-']"
              label="TEAM"
              background-color="#ECEFF1"
              multiple
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-col cols="12" class="my-0 py-0">
            <v-autocomplete
              attach
              v-model="sterm.email"
              :items="lst_email"
              label="Records created by"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select
              attach
              v-model="sterm.area"
              :items="area_items"
              label="Area"
              required
              background-color="#ECEFF1"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              attach
              v-model="sterm.deeds_hours"
              :items="dhours15"
              label="DEEDS Hours >="
              required
              background-color="#ECEFF1"
            ></v-select>
          </v-col>
        </v-row>
        <!-- <v-row dense no-gutters>
          <v-col cols="12">
            <v-select
              attach
              v-model="sterm.mission"
              :items="mission_types"
              label="Misson"
              required
              background-color="#ECEFF1"
            ></v-select>
          </v-col>
        </v-row> -->
        <v-row id="rowaddflds" dense no-gutters>
          <v-col cols="12" md="12">
            <div class="d-flex">
              <v-select
                attach
                :items="items_stat_fields"
                :item-text="'name'"
                :item-value="value"
                label="Fields to Search By"
                solo
                v-model="selected_stat_fields"
              ></v-select>
              <v-btn class="mt-2 ml-3" color="success" @click="add_field"
                >ADD</v-btn
              >
            </div>
          </v-col>
        </v-row>
        <h4 v-if="lst_fields.length > 0">Also Filter By...</h4>
        <v-row id="allfieldsrow" dense no-gutters>
          <v-col cols="12" md="12">
            <div class="text-center">
              <v-chip
                v-for="fld in lst_fields"
                :key="fld"
                color="blue"
                text-color="white"
                class="ma-2"
                close
                @click="remove_field(fld)"
                @click:close="remove_field(fld)"
              >
                {{ fld }}
              </v-chip>
            </div>
          </v-col>
        </v-row>

        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <!-- viusible only on phones -->
            <div class="hide-if-large d-flex justify-space-around align-start">
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Any terms Above
              </div>
              <v-switch v-model="sterm.all" label=""></v-switch>
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Only Terms Above
              </div>
            </div>
            <!-- visble on everything but phones -->
            <div class="hide-if-small d-flex justify-center align-start">
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Any terms Above
              </div>
              <v-switch v-model="sterm.all" label=""></v-switch>
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Only Terms Above
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="bReady_to_update">
          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn color="cmpbk" class="mr-4 white--text" @click="search">
              Search
            </v-btn>
            <v-btn color="cmpbk" class="mr-4 white--text" @click="reset">
              Clear Form
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
#chk-all.v-icon.v-icon {
  color: white !important;
}
@media (min-width: 0px) {
  .hide-if-small {
    display: none !important;
  }
  // .hide-if-large {
  //   display: none !important;
  // }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 100%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 40%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
}
select {
  -webkit-appearance: listbox !important;
  appearance: listbox !important;
}
</style>

<script>
/* eslint-disable */
import { mdiSelectionEllipseArrowInside } from "@mdi/js";
import { bus_common } from "../mixins/bus_common";
export default {
  name: "search27",
  mixins: [bus_common],
  props: ["update_search_results_27"],
  //search data

  data() {
    return {
      picker_show: false,
      lst_fields: [],
      selected_stat_fields: "",
      //       rpd_stat_27_Id: 0,

      // area: "",
      // other_area: "",

      // deeds_hours: "0.00",
      // patrol_investigations: 0,
      // subject_stops: 0,
      // gtar: 0,

      // planned_operations: 0,
      // cfs_handled: 0,
      // cfs_handled_reports: 0,
      // felony_arrests: 0,

      // gross_mido_arrests: 0,
      // misdo_arrests: 0,
      // rmc_cites: 0,
      // traffic_stops: 0,

      // traffic_citations: 0,
      // warnings: 0,
      // area_check: 0,
      // business_check: 0,

      // bus_contacts: 0,
      // citizen_contacts: 0,
      // substances_seized: 0,
      // firearms_seized: 0,

      // vehicle_posted: 0,
      // vehicle_towed: 0,
      // notes: "",
      items_stat_fields: [
        { name: "area", value: "area" },
        { name: "patrol_investigations", value: "patrol_investigations" },
        { name: "subject_stops", value: "subject_stops" },
        { name: "gtar", value: "gtar" },
        { name: "planned_operations", value: "planned_operations" },
        { name: "cfs_handled", value: "cfs_handled" },
        { name: "cfs_handled_reports", value: "cfs_handled_reports" },
        { name: "felony_arrests", value: "felony_arrests" },
        { name: "gross_mido_arrests", value: "gross_mido_arrests" },
        { name: "misdo_arrests ", value: "misdo_arrests" },
        { name: "rmc_cites", value: "rmc_cites" },
        { name: "traffic_stops", value: "traffic_stops" },
        { name: "traffic_citations", value: "traffic_citations" },
        { name: "warnings", value: "warnings" },
        { name: "area_check", value: "area_check" },
        { name: "business_check", value: "business_check" },
        { name: "bus_contacts", value: "bus_contacts" },
        { name: "citizen_contacts", value: "citizen_contacts" },
        { name: "citizen_contacts", value: "citizen_contacts" },
        { name: "firerams_seized", value: "firerams_seized" },
        { name: "vehicle_posted", value: "vehicle_posted" },
        { name: "vehicle_towed", value: "vehicle_towed" },
      ],
      rawdata: {},
      lst_email: [],
      // values: [],
      lst_users: [],
      bReady_to_update: true,
      valid: true,
      daterule: [
        (v) =>
          v == "" ||
          (new Date(v) !== "Invalid Date" && !isNaN(new Date(v))) ||
          "Must be a valid date.",
      ],
      types: ["All", "Traffic", "Warrant", "Dispatch", "Complaint"],
      area_items: [
        "ALL",
        "Downtown Corridor",
        "DEEDS",
        "City of Reno",
        "Other",
      ],
      mission_types: [
        "All",
        "DID Operation (ex: 4th street saturation Op/ Shopping Cart Op/ UC op)",
        "Area Check",
        "Ambassador Assist",
        "Business Check",
        "Call for Service",
        "Camp Cleanup",
        "City Walk",
        "Service Request",
        "Warrant Sweep",
        "Motel Inspection",
        "CPTED",
        "Other",
      ],
      sterm: {
        dates: [],
        team: "",
        deed_hours: "",
        area: "All",
        other_area: "",
        all: false,
        email: "",
      },
      sterm_new: {
        dates: [],
        team: "",
        deed_hours: "0.00",
        area: "All",
        other_area: "",
        all: false,
        email: "",
      },
    };
  },
  watch: {
    update_search_results_27: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.bReady_to_update && val != null) {
          this.search();
        }
      },
    },
  },
  computed: {
    dhours15() {
      let dhours15 = [];
      for (let hour = 0; hour <= 20; hour++) {
        for (let minutes = 0; minutes < 60; minutes += 15) {
          // let inc = `${hour.toString().padStart(2, "0")}:${minutes
          //   .toString()
          //   .padStart(2, "0")}`;
          let inc = (parseFloat(hour) + parseFloat(minutes / 100)).toFixed(2);
          dhours15.push(inc);
        }
      }
      return dhours15;
    },
    dateRangeText() {
      if (this.sterm.dates[0] == undefined) {
        return (
          this.format_date_us(new Date()) +
          "~" +
          this.format_date_us(new Date())
        );
      }
      return (
        this.format_date_us(new Date(this.sterm.dates[0])) +
        "~" +
        this.format_date_us(new Date(this.sterm.dates[1]))
      );
    },
    hours() {
      var hrs = [];
      hrs.push("None");
      for (let i = 1; i < 24; i++) {
        hrs.push((i * 100).toString().padStart(4, "0"));
      }
      return hrs;
    },
    days() {
      var dys = [];
      dys.push("None");
      for (let i = 0; i < 120; i++) {
        var today = new Date();
        today.setDate(today.getDate() - i);
        var x = this.format_date_us(today);
        dys.push(x);
      }
      return dys;
    },
    d20() {
      var d20 = [];
      for (let index = 0; index < 21; index++) {
        d20.push(index);
      }
      return d20;
    },
  },
  methods: {
    toggle_picker() {
      this.picker_show = !this.picker_show;
    },
    remove_field(str) {
      console.log("remove_field " + str);
      this.removeStringFromArray(this.lst_fields, str);
    },
    add_field() {
      this.lst_fields.push(this.selected_stat_fields);
      this.selected_stat_fields = "";
    },
    message1() {
      alert("This button does nothing yet.");
    },
    reset() {
      this.lst_fields = [];
      this.sterm = this.mno(this.sterm_new);
      this.$emit("search_cleark9");
    },
    search() {
      //this.show_loader(true);
      console.log("search", this.sterm);
      //make new objet
      let sterm = this.mno(this.sterm);
      sterm.dates = this.dateRangeText;
      if (this.sterm.team.length > 0) {
        sterm.team = this.sterm.team.join("|");
      } else {
        sterm.team = "";
      }
      sterm.lst_fields = this.lst_fields.join("|");

      this.$emit("search27", sterm);
      this.$emit("open_search_results");
    },
    init() {
      this.sterm = this.mno(this.sterm_new);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "get_destinct_s_users27";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.rawdata = data;
          this.lst_users = this.mno(data);
          this.lst_email = this.mno(this.lst_users);
          //this.values = this.mno(this.lst_users);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error lst_users", msg, "error", null, null);
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
